import { FC, memo } from 'react'
import { Button } from '@maas-components/core'
import { HorizontalSplitOutlined, ViewDayOutlined } from '@maas-components/icons'
import i18n from 'core/common/i18n'

interface IProps {
  show: boolean
  isBulkMode: boolean
  onClick: () => void
}

const BulkModeButton: FC<IProps> = ({ show, onClick, isBulkMode }) => {
  if (!show) {
    return null
  }

  const renderButtonContent = () =>
    isBulkMode ? (
      <>
        <HorizontalSplitOutlined className="mr-1" />
        {i18n.t('multivariation.variationValue.variationFill')}
      </>
    ) : (
      <>
        <ViewDayOutlined className="mr-1" /> {i18n.t('multivariation.variationValue.bulkFill')}
      </>
    )

  return (
    <Button color="primary" onClick={onClick}>
      {renderButtonContent()}
    </Button>
  )
}

export default memo(BulkModeButton)
